const max = values => {
  var max_v = values[0];

  values.forEach(v => {
    if (v > max_v) max_v = v;
  });

  return max_v;
}

const ascending = (a, b) => {
  return a == null || b == null ? NaN
    : a < b ? -1
      : a > b ? 1
        : a >= b ? 0
          : NaN;
}

const descending = (a, b) => {
  return a == null || b == null ? NaN
    : b < a ? -1
      : b > a ? 1
        : b >= a ? 0
          : NaN;
}

// hontza related
const uniquePropertyValues = (data, propertyName) => {
  return [...new Set( data.map( d => d[propertyName] ) )];
}

// const intersect = (a, b) => {
//   return a.filter( v => b.includes( v ) );
// }

const intersection = (arrays) => {
  return arrays.reduce( (a, b) => a.filter( v => b.includes( v ) ) );
}

const arrayAt = (a, index) => {
  /* for very old browsers */
	// ToInteger() abstract op
	index = Math.trunc(index) || 0;
	// Allow negative indexing from the end
	if (index < 0) index += a.length;
	// OOB access is guaranteed to return undefined
	if (index < 0 || index >= a.length) return undefined;
	// Otherwise, this is just normal property access
	return a[index];
}

const dataTools = {
  max,
  ascending,
  descending,
  uniquePropertyValues,
  intersection,
  arrayAt
}

export default dataTools



// WEBPACK FOOTER //
// ./src/utils/dataTools.js